// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__jFOqL","tab-panel":"Tabs_tab-panel__TxYeM"};